const layoutConsts = {
  sitewidth: 600
}

export default layoutConsts